import React from 'react'

import { Grid } from '@material-ui/core'

import SkillsAndHobbiesSelection from './components/SkillsAndHobbiesSelection/SkillsAndHobbiesSelection'
import Divider from '@material-ui/core/Divider'
import CollectionHandler from 'assets/CollectionHandler'

const SkillsAndHobbiesProfileViewDefault = (props) => {
    const {
        setStudentSkillsAndHobbies,
        studentSkillsAndHobbies
    } = props

    const skillsList = CollectionHandler.Get('workSkillCollection')

    return (
        <Grid>
            <SkillsAndHobbiesSelection
                Title={'Hard Skills...'}
                skillType={'hard'}
                availableSkills={skillsList.filter(skill => skill.skill_type === 'hard')}
                setStudentSkillsAndHobbies={setStudentSkillsAndHobbies}
                studentSkillsAndHobbies={studentSkillsAndHobbies}
            />
            <Divider orientation='horizontal' style={{ width: '100%', marginTop: 20 }}/>
            <SkillsAndHobbiesSelection
                Title={'Soft Skills...'}
                skillType={'soft'}
                availableSkills={skillsList.filter(skill => skill.skill_type === 'soft')}
                setStudentSkillsAndHobbies={setStudentSkillsAndHobbies}
                studentSkillsAndHobbies={studentSkillsAndHobbies}
            />
        </Grid>
    )
}

export default SkillsAndHobbiesProfileViewDefault
